import { Interface, toQuantity } from 'ethers';
export type ReviewedProvider={request:(args:{method:string;params?:any})=>Promise<any>};
export async function estimateReviewedDebit(provider:ReviewedProvider,tx:{to:string;data:string;value:string},address:string){
 const request={from:address,to:tx.to,data:tx.data,value:toQuantity(BigInt(tx.value||'0'))};
 const [gas,price,balance]=await Promise.all([provider.request({method:'eth_estimateGas',params:[request]}),provider.request({method:'eth_gasPrice'}),provider.request({method:'eth_getBalance',params:[address,'latest']})]);
 const gasWei=BigInt(gas)*BigInt(price),totalWei=BigInt(tx.value||'0')+gasWei;
 return {gasWei:gasWei.toString(),totalWei:totalWei.toString(),remainingWei:(BigInt(balance)-totalWei).toString()};
}
export async function sendReviewedTransaction(provider:ReviewedProvider,tx:{to:string;data:string;value:string;chainId:number},address:string,assertCurrent:()=>void) {
  const check=async()=>{
    assertCurrent();
    const accounts=await provider.request({method:'eth_accounts'});
    const chain=await provider.request({method:'eth_chainId'});
    assertCurrent();
    if(accounts[0]?.toLowerCase()!==address.toLowerCase()||Number(chain)!==tx.chainId)throw new Error('The wallet network or account changed. Review the transaction again.');
  };
  await check();
  const request={from:address,to:tx.to,data:tx.data,value:toQuantity(BigInt(tx.value||'0')),chainId:toQuantity(tx.chainId)};
  const gas=await provider.request({method:'eth_estimateGas',params:[request]});
  await check();
  // No asynchronous preparation between this guard and submission. The wallet must
  // also enforce the explicit chainId if its network changes inside its own prompt.
  assertCurrent();
  return provider.request({method:'eth_sendTransaction',params:[{...request,gas}]}) as Promise<string>;
}
export function completedStepWarning(steps:{to:string;data:string;description:string}[]) {
  if(!steps.length)return '';
  const decoder=new Interface(['function approve(address spender,uint256 amount)']);
  const approvals=steps.flatMap(step=>{try{const value=decoder.parseTransaction({data:step.data});return value?[`Approval remains effective: ${value.args.amount.toString()} raw token units, spender ${value.args.spender}, token ${step.to}.`]:[];}catch{return [];}});
  return ` ${steps.length} earlier step(s) already confirmed and network gas was spent. ${approvals.join(' ')}${approvals.length?' You can review and revoke the remaining allowance in your wallet; revocation is a separate transaction.':''}`;
}
